import React from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { config } from './config';

interface SelfHostedEditorProps {
  onInit?: (evt: any, editor: any) => void;
  onChange?: (event: any, editor: any) => void;
  initialValue?: string;
  value?: string;
  init?: any;
}

/**
 * Self-hosted TinyMCE Editor component
 * This component uses the self-hosted TinyMCE files from /public/tinymce
 * No API key is required when using self-hosted version
 */
const SelfHostedEditor: React.FC<SelfHostedEditorProps> = ({
  onInit,
  onChange,
  initialValue,
  value,
  init,
}) => {
  return (
    <Editor
      tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
      onInit={onInit}
      onChange={onChange}
      initialValue={initialValue}
      value={value}
      init={init || config}
    />
  );
};

export default SelfHostedEditor;

